import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { LoHangTapTinDinhKem } from './LoHangTapTinDinhKem.model';
import { BaseService } from './Base.service';
@Injectable({
    providedIn: 'root'
})
export class LoHangTapTinDinhKemService extends BaseService{

    DisplayColumns001: string[] = ['DanhMucTapTinDinhKemPhanLoaiID', 'NgayCap', 'Save'];
        
    List: LoHangTapTinDinhKem[] | undefined;
    ListFilter: LoHangTapTinDinhKem[] | undefined;
    FormData!: LoHangTapTinDinhKem;

    constructor(public httpClient: HttpClient) {
        super(httpClient);
        this.Controller = "LoHangTapTinDinhKem";
    }
}

